<template>
  <component :is="JoinStarRewardsPerkComponent" />
</template>

<script setup>
/* istanbul ignore file */
import { defineAsyncComponent } from 'vue';
import { useEnvProps } from '~/composables/useEnvProps';

const { brand } = useEnvProps();
const JoinStarRewardsPerkComponent = defineAsyncComponent(() => import(`./JoinStarRewardsPerk.${brand}.vue`));
</script>
